import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../Page.module.scss';
import MainWrapper from '../Utils/MainWrapper';
import ClickableItem from '../Utils/ClickableItem';

function TabItem({
  title, url, favicon,
}) {
  return (
    <ClickableItem url={url}>
      <img className={styles.favicon} src={favicon} alt="" />
      <span className={styles.title}>{title}</span>
      <span className={styles.url}>{url}</span>
    </ClickableItem>
  );
}

TabItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  favicon: PropTypes.string.isRequired,
};

function Window({ name, count }) {
  return (
    <div className={styles.listTitle}>
      <span>{name}</span>
      <span>{count}</span>
    </div>
  );
}

Window.propTypes = {
  name: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

function Tabs({ tabs }) {
  const { t } = useTranslation();

  return (
    <MainWrapper caption={t('Open tabs')}>
      {
        tabs.map((window) => (
          <div key={window.id} className={styles.list}>
            <Window name={window.name} count={window.tabs.length} />
            {
              window.tabs.map((tab) => (
                <TabItem key={tab.id} title={tab.title} url={tab.url} favicon={tab.favicon} />
              ))
            }
          </div>
        ))
      }
    </MainWrapper>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.instanceOf(Array).isRequired,
};

export default Tabs;
